import { initials } from "@/lib/account";
import { cn } from "@/lib/utils";

/** A user's picture, or their initials on a tinted circle. */
export function Avatar({
  user,
  className,
}: {
  user: { firstName: string | null; lastName: string | null; avatarUrl: string | null };
  className?: string;
}) {
  if (user.avatarUrl) {
    return (
      <img
        src={user.avatarUrl}
        alt=""
        className={cn("size-8 shrink-0 rounded-full object-cover ring-1 ring-border", className)}
      />
    );
  }
  return (
    <span
      aria-hidden
      className={cn(
        "flex size-8 shrink-0 items-center justify-center rounded-full bg-brand-soft text-xs font-semibold text-brand-fg ring-1 ring-border",
        className,
      )}
    >
      {initials(user) || "?"}
    </span>
  );
}
